/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetConvertUnixtimeRequest = { time: string };

export const GetConvertUnixtimeRequest$zodSchema: z.ZodType<
  GetConvertUnixtimeRequest
> = z.object({
  time: z.string().describe(
    "一个智能时间参数，可传入Unix时间戳（10位或13位）或标准日期字符串（如 '2023-10-27 10:30:00'），系统将自动识别并转换。",
  ),
});

/**
 * 包含错误详情的对象。
 */
export type GetConvertUnixtimeDetails = {};

export const GetConvertUnixtimeDetails$zodSchema: z.ZodType<
  GetConvertUnixtimeDetails
> = z.object({}).describe("包含错误详情的对象。");

/**
 * 请求失败。请检查你提供的 `time` 参数是否是有效的时间戳或我们支持的日期格式（YYYY-MM-DD HH:mm:ss）。
 */
export type GetConvertUnixtimeBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetConvertUnixtimeDetails | undefined;
  message?: string | undefined;
};

export const GetConvertUnixtimeBadRequestResponseBody$zodSchema: z.ZodType<
  GetConvertUnixtimeBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetConvertUnixtimeDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "请求失败。请检查你提供的 `time` 参数是否是有效的时间戳或我们支持的日期格式（YYYY-MM-DD HH:mm:ss）。",
);

/**
 * 转换成功！响应中会同时包含标准日期字符串和秒级Unix时间戳，方便你使用。
 */
export type GetConvertUnixtimeResponseBody = {
  datetime?: string | undefined;
  timestamp?: number | undefined;
};

export const GetConvertUnixtimeResponseBody$zodSchema: z.ZodType<
  GetConvertUnixtimeResponseBody
> = z.object({
  datetime: z.string().optional(),
  timestamp: z.int().optional(),
}).describe(
  "转换成功！响应中会同时包含标准日期字符串和秒级Unix时间戳，方便你使用。",
);

export type GetConvertUnixtimeResponse =
  | GetConvertUnixtimeResponseBody
  | GetConvertUnixtimeBadRequestResponseBody;

export const GetConvertUnixtimeResponse$zodSchema: z.ZodType<
  GetConvertUnixtimeResponse
> = z.union([
  z.lazy(() => GetConvertUnixtimeResponseBody$zodSchema),
  z.lazy(() => GetConvertUnixtimeBadRequestResponseBody$zodSchema),
]);
